import { render, staticRenderFns } from "./SelectA.vue?vue&type=template&id=72cc1176"
import script from "./SelectA.vue?vue&type=script&lang=js"
export * from "./SelectA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports